/** recipes slider */

// import Swiper from 'Vendor/swiper.js';
// import $ from "jquery";

import Swiper, { Navigation, Pagination } from 'swiper';

let swiperRecipes = undefined;

export default function recipesSlider() {
	if (!$('.recipes-slider').length) return;
	// let windowWidth = $(window).width();

	// if (windowWidth <= 991) {

	// When Carousel exists
	if (recipesSlider) {

		function initSlider() {
			let $obj = $('.recipes-slider');

			const swiperCarousels = document.querySelectorAll(".recipes-swiper");

			swiperCarousels.forEach(carouselContainer => {
				let $this = $(carouselContainer);


				const carouselPagination = carouselContainer.querySelector(
					".swiper-pagination"
				);

				const carouselPrevButton =
					carouselContainer.querySelector(".swiper-button-prev") ||
					carouselContainer.parentElement.querySelector(
						".swiper-button-prev" // <-- this is how you can have the Prev Button outside the swiper container
					);

				const carouselNextButton =
					carouselContainer.querySelector(".swiper-button-next") ||
					carouselContainer.parentElement.querySelector(
						".swiper-button-next" // <-- this is how you can have the Next Button outside the swiper container
					);

				if (!$this.hasClass('swiper-horizontal')) {
					swiperRecipes = new Swiper(carouselContainer, {
						modules: [Navigation, Pagination],
						slideToClickedSlide: true,
						preloadImages: true,
						slidesPerView: 'auto',
						// slidesPerView: 1.25,
						// slidesPerGroup: 1,
						// loopedSlides: 6,
						spaceBetween: 15,
						centeredSlides: true, //start from center -> true
						// lazy: true,
						loop: false,
						lazy: {
							loadPrevNext: true,
							loadPrevNextAmount: 10,
						},
						navigation: {
							nextEl: carouselNextButton,
							prevEl: carouselPrevButton
						},
						pagination: {
							el: carouselPagination,
							clickable: true,
							dynamicBullets: false
						},
						breakpoints: {
							768: {
								// slidesPerView: 'auto',
								// slidesPerGroup: 1,
								// // centeredSlides: true,
								// // spaceBetween: 10,
								// // loop: true,
								// noSwiping: false
							},
							991: {
								slidesPerView: 3,
								// slidesPerGroup: 3,
								centeredSlides: false,
								// spaceBetween: 10,
								// loop: true,
								noSwiping: false
							}
						}
					});
				}
			});
		}


		initSlider();
	}
};
